import { BaseChart } from "./BaseChart";
import { TimePeriod } from "./TimePeriodSelector";
import type { WaistSizeResponse } from "@/types/tracker";
import { processSimpleTrackerChartData } from "./utils";
import { getMetricColor } from "./chart-theme";

interface WaistChartProps {
  data: WaistSizeResponse | null;
  selectedPeriod: TimePeriod;
  currentDate: Date;
}

export const WaistChart = ({
  data,
  selectedPeriod,
  currentDate,
}: WaistChartProps) => {
  const yAxisConfig = data?.y_axis || { min: 50, max: 100 };
  const chartData = processSimpleTrackerChartData(
    data,
    selectedPeriod,
    currentDate
  );

  return (
    <BaseChart
      data={chartData}
      selectedPeriod={selectedPeriod}
      currentDate={currentDate}
      yAxisConfig={yAxisConfig}
      chartColor={getMetricColor("waist-size")}
      metricName="Waist Size"
      unit="cm"
    />
  );
};
